/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'

const ContentComponent = () => {
  const [dataYoutube, setDataYoutube] = useState()
  const keyApi = `AIzaSyCQGCRxR2HjvLrxiwHR2vRYFwoOL3dpfUY`
  const channelId = `UCYjhMXDnujBM4Gz_E0jzUDg`
  const result = 10

  var finalUrl = `https://youtube.googleapis.com/youtube/v3/activities?key=${keyApi}&channelId=${channelId}&part=snippet&maxResults=${result}`

  //Data Youtube
  const fetchData = async () => {
    try {
      const fetchApi = await fetch(`${finalUrl}`, {
        method: 'GET',
      })
      const dataApi = await fetchApi.json()
      console.log(dataApi.items)
      setDataYoutube(dataApi.items)
    } catch (error) {
      console.log('error')
      alert(error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <main>
      {/* Hero Area Start */}
      <div
        className="hero-area hero-height2 d-flex align-items-center"
        data-background="assets/img/hero/h2_hero.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="hero-cap text-center pt-50">
                <h2>Konten Terbaru Kami</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Hero Area End */}
      {/* David Droga start */}
      <div className="david-droga-area pb-160" style={{ marginTop: '11%' }}>
        <div className="container">
          <div className="row">
            {dataYoutube ? (
              dataYoutube.map((item) => {
                const date = new Date(item.snippet.publishedAt)
                console.log(date.get)
                return (
                  <div className="col-xl-6 col-lg-6 col-md-6">
                    {/* single-david */}
                    <div className="single-david mb-30">
                      <div className="david-img">
                        <img
                          src={item.snippet.thumbnails.high.url}
                          alt={item.snippet.thumbnails.high.url}
                        />
                      </div>
                      <div className="david-captoin">
                        <h2>
                          <a href="#">{item.snippet.title}</a>
                        </h2>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className="col-xl-6 col-lg-6 col-md-6">
                {/* single-david */}
                <div className="single-david mb-30">
                  <div className="david-img">
                    <Skeleton />
                  </div>
                  <div className="david-captoin">
                    <ul className="david-info">
                      <li>
                        <Skeleton />
                      </li>
                    </ul>
                    <h2>
                      <a href="#">
                        <Skeleton />
                      </a>
                    </h2>
                    <span>
                      <Skeleton />
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
          {dataYoutube ? (
            <div class="row justify-content-center">
              <div class="room-btn pt-50">
                <a
                  href="https://www.youtube.com/channel/UCYjhMXDnujBM4Gz_E0jzUDg"
                  class="btn"
                >
                  Load more
                </a>
              </div>
            </div>
          ) : (
            <div class="room-btn pt-50">
              <Skeleton />
            </div>
          )}
        </div>
      </div>
      {/* David Droga End */}
      {/* Want To Work Start */}
      <div className="wantToWork-area wantToWork-area2 w-padding2">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-8 col-lg-8 col-md-8">
              <div className="wantToWork-caption wantToWork-caption2">
                <h2>
                  Segera hubungi kami dan buat bisnis anda menjadi digital
                  dengan kami.
                </h2>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4">
              <a href="/contact" className="btn btn-black f-right">
                contact us now
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Want To Work End */}
    </main>
  )
}

export default ContentComponent
